import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { windowSelectors } from 'models/window'
import { Modal } from './modal'
import { modalNames } from './constants/names'
import { CaseModal } from '../profile/case-modal'
import { PromoCodeModal } from './components/promo-code-modal'
import { ReferralWelcomeModal } from './components/referral-welcome-modal'
import { ConfirmModal } from './components/confirm-modal'
import { GameSelectModal } from './components/game-select-modal'
import { CaseRewardModal } from './components/case-reward-modal'
import { SiteIdHelpModal } from './components/site-id-help-modal'
import { LeaderboardRewardModal } from './components/leaderboard-reward-modal'

export const Modals = () => {
    const name = useSelector(windowSelectors.name)
    const props = useSelector(windowSelectors.props)
    const [template, setTemplate] = useState(null)

    useEffect(() => {
        if (name) {
            switch (name) {
                case modalNames.CASE_MODAL:
                    setTemplate(<CaseModal {...(props || {})} />)
                    break
                case modalNames.PROMO_CODE_MODAL:
                    setTemplate(<PromoCodeModal {...(props || {})} />)
                    break
                case modalNames.REFERRAL_WELCOME_MODAL:
                    setTemplate(<ReferralWelcomeModal {...(props || {})} />)
                    break
                case modalNames.CONFIRM_MODAL:
                    setTemplate(<ConfirmModal {...(props || {})} />)
                    break
                case modalNames.GAME_SELECT_MODAL:
                    setTemplate(<GameSelectModal {...(props || {})} />)
                    break
                case modalNames.CASE_REWARD_MODAL:
                    setTemplate(<CaseRewardModal {...(props || {})} />)
                    break
                case modalNames.SITE_ID_HELP_MODAL:
                    setTemplate(<SiteIdHelpModal {...(props || {})} />)
                    break
                case modalNames.LEADERBOARD_REWARD_MODAL:
                    setTemplate(<LeaderboardRewardModal {...(props || {})} />)
                    break
                default:
                    setTemplate(null)
            }
        }
    }, [name, props])

    return (
        <Modal opened={!!name} onExited={() => setTemplate(null)}>
            {template}
        </Modal>
    )
}
